import script from "./NewItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NewItem.vue?vue&type=script&setup=true&lang=js"

import "./NewItem.vue?vue&type=style&index=0&id=504d23a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504d23a2"]])

export default __exports__